import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { ConfirmAlert, DeleteAlert } from './va-alert/default-alerts';
import { VaAlertComponent } from './va-alert/va-alert.component';

@Injectable({ providedIn: 'root' })
export class VaDialogService {
  constructor(private dialog: MatDialog) {}

  public delete(
    titleText: string,
    subtitleText: string,
    confirmButtonText: string,
    cancelButtonText = 'Cancel',
    modalWidth = 420,
  ): Observable<any> {
    const deleteAlert = new DeleteAlert(titleText, subtitleText, confirmButtonText, cancelButtonText);
    const dialogRef: MatDialogRef<VaAlertComponent> = this.dialog.open(VaAlertComponent, {
      width: `${modalWidth}px`,
    } as MatDialogConfig);
    dialogRef.componentInstance.alert = deleteAlert;

    return dialogRef.afterClosed();
  }

  public confirm(
    titleText: string,
    subtitleText: string,
    confirmButtonText: string,
    cancelButtonText = 'Cancel',
    modalWidth = 420,
  ): Observable<any> {
    const confirmAlert = new ConfirmAlert(titleText, subtitleText, confirmButtonText, cancelButtonText);
    const dialogRef: MatDialogRef<VaAlertComponent> = this.dialog.open(VaAlertComponent, {
      width: `${modalWidth}px`,
    } as MatDialogConfig);
    dialogRef.componentInstance.alert = confirmAlert;

    return dialogRef.afterClosed();
  }

  public confirmDialog(
    titleText: string,
    subtitleText: string,
    confirmButtonText: string,
    cancelButtonText = 'Cancel',
    modalWidth = 420,
  ): MatDialogRef<VaAlertComponent> {
    const confirmAlert = new ConfirmAlert(titleText, subtitleText, confirmButtonText, cancelButtonText);
    const dialogRef: MatDialogRef<VaAlertComponent> = this.dialog.open(VaAlertComponent, {
      width: `${modalWidth}px`,
    } as MatDialogConfig);
    dialogRef.componentInstance.alert = confirmAlert;

    return dialogRef;
  }
}
